import Vue from "vue";
import { getQueryString } from "@/utils/url";

import VueI18n from "vue-i18n";
import zh_CN from "./zh/index";
import en from "./en/index";
import zh_HK from "./zh-HK/index";
import { Local } from "./vantLocale";

Vue.use(VueI18n);
const DEFAULT_LANG = "zh-CN";
const LOCALE_KEY = "localLang";

interface Locales extends Object {
  [key: string]: any;
}

const locales: Locales = {
  "zh-CN": zh_CN,
  en,
  "zh-HK": zh_HK
};
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
});
Local(DEFAULT_LANG);
// Vue.prototype.$Local = Local;

export const setup = () => {
  let lang = getQueryString("lang");
  if (lang && locales[lang] !== undefined) {
    i18n.locale = lang;
    Local(lang);
    window.localStorage.setItem(LOCALE_KEY, lang);
  } else {
    lang = window.localStorage.getItem(LOCALE_KEY) || "";
    if (locales[lang] !== undefined) {
      i18n.locale = lang;
      Local(lang);
    } else {
      // lang = navigator.language;
      // if (lang && locales[lang] !== undefined) {
      //   i18n.locale = lang;
      // }
    }
  }
  if(lang == 'en'){
    document.documentElement.lang = "en";
  }else{
    document.documentElement.lang = "zh";
  }
};

setup();

export default i18n;
